import Api from "../api";

let uri = "/api/ed/usuario";

export const getUsuarios = () => {
  return Api.getInstance()
    .executeGetQuery(uri)
    .then((res) => res.data)
    .catch((err) => console.log(err));
};

export const createUsuario = (data) => {
  return Api.getInstance()
    .executeQuery(uri, data)
    .then((res) => res)
    .catch((err) => console.log(err));
};

export const editUsuario = (data) => {
  return Api.getInstance()
    .executeUpdateQuery(uri, data)
    .then((res) => res)
    .catch((err) => console.log(err));
};

export const deleteUsuario = (data) => {
  return Api.getInstance()
    .executeDeleteQuery(uri, { data: data })
    .then((res) => res)
    .catch((err) => console.log(err));
};

export const existsUser = (data) => {
  return Api.getInstance()
    .executeQuery("/api/ed/validacion/", data)
    .then((res) => res)
    .catch((err) => console.log(err));
};

export const getUsuarioPerfil = (data) => {
  return Api.getInstance()
    .executeQuery(uri + "/perfil", data)
    .then((res) => res.data);
};

export const getUsuarioPerfilFull = (data) => {
  return Api.getInstance()
    .executeQuery(uri + "/perfil", data)
    .then((res) => res);
};

export const patchUsuarioPerfil = (data) => {
  return Api.getInstance()
    .executeUpdateQuery(uri + "/perfil", data)
    .then((res) => res);
};

export const getUsuarioEstadisticas = (data) => {
  return Api.getInstance()
    .executeQuery(uri + "/estadisticas", data)
    .then((res) => res.data);
};

export const getUsuarioEstadisticasFull = (data) => {
  return Api.getInstance()
    .executeQuery(uri + "/estadisticas", data)
    .then((res) => res);
};
